///<reference path="../common/limitations-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    export class ReportTaxesLimitations extends LimitationsBase implements ILimitationsBase {

        limitationReached(lastChangedModel: CollectionModel<any>): boolean {
            return this.collection.selectedModels.length > MAX_SELECTED_TAXES;
        }
    }
}
